import { request } from "./api-require";
import { objAny } from "../common/common-interface";

const API_URL = "/basic-system/v1";
//登录
export const getAppUpdateInfo = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/app/upgrade/list", data, config);
};

/**
 * 新增应用更新信息
 * @param data
 * @param config
 */
export const addAppUpdateInfo = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/app/upgrade/upd_app_upgrade", data, config);
};

/**
 * 修改状态
 * @param data
 * @param config
 */
export const invalidateUpgradeStatus = (data = {}, config = {}) => {
  return request(API_URL + "/app/upgrade/upd_status", data, config);
};
